/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'require',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'jquery',
	'underscore'
], function(require, View, $, _) {

	var InputView = View.extend({
		baseClass : 'toolbar',

		flyoutModule :  '../../utils/Flyout',

		init : function(config) {
			_.extend(this, config);
			InputView.inherited('init', this, arguments);

			this.$input = $('<input type="search" placeholder="' + this.label + '">');
			this.suspendKeyHandling = false;

			if( config.isDisabled ) {
				this.disable();
			}

			this.$input
				.keypress(this.onKeypress.bind(this))
				.on('keyup', (e) => {
					//stop propagation for delete key
					if (!this.suspendKeyHandling && (e.keyCode === 46 || e.keyCode === 8)) {
						e.stopPropagation();
					}
				})
				.on('keydown', (e) => {
					//stop propagation for space key
					if (!this.suspendKeyHandling && e.keyCode === 32) {
						e.stopPropagation();
					}
				})
				.on('dblclick', () => {
					this.focus();
				});
		},

		/**
		 * Draws the Label
		 */
		render : function() {
			this.$el.empty();
			if(this.styleName) {
				this.$el.addClass(this.styleName);
			}
			this.$el.prepend(this.$input);
			return this;
		},

		focus: function() {
			if(this.$input) {
				this.$input.focus();
				this.$input[0].setSelectionRange(0, 9999);
			}
		},

		/*
		 * Cancel the current input
		 */
		cancel: function() {
			if(this.flyout) {
				this._clearFlyout();	//Callback from this invokes this.clear()
			} else {
				this.clear();
			}
		},

		/*
		 * Helper to clear input field
		 */
		clear: function() {
			this.$input.val('');
		},

		/*
		 * Does cleanup
		 */
		remove: function() {
			return this._clearFlyout()
				.then(() => {
					if(this.$input) {
						this.$input.off();
						this.$input.remove();
						this.$input = null;
					}
				});
		},

		disable: function() {
			this.$input.attr('disabled','disabled');
		},

		enable: function() {
			this.$input.removeAttr('disabled');
		},

		onKeypress: function() {
		},

		/**
		 * Helper to show notification in a flyout placed around input field
		 * @param params - provides options to create flyout
		 */
		showNotification: function(params) {
			return this._clearFlyout()
				.then(this._loadModule.bind(this, this.flyoutModule))
				.then((Flyout) => {
					var options = _.extend({
						selector: this.$input,
						viewClass: params.viewClass,
						popoverClass: 'quickAddPopover',
						once: true,
						onVisible: this._onFlyoutVisible.bind(this)
					}, params);

					this.flyout = new Flyout(options);
					this._showFlyout(this.flyout);
				});
		},

		_loadModule: function(module) {
			return new Promise((resolve, reject) => {
				try {
					require([module], resolve, reject);
				} catch(error) {
					reject(error);
				}
			});
		},

		_onFlyoutVisible: function() {},

		_showFlyout:function(flyout /*used for unit testing*/){
			flyout.open(this.$input);
		},

		_clearFlyout: function() {
			if(this.flyout) {
				return this.flyout.destroy()
					.then(() => {
						this.flyout = null;
					});
			}
			return Promise.resolve();
		}
	});

	return InputView;
});
